import { ZONES } from "../data/site";
import { useContents } from "../hooks/useContents";

export const Marquee = () => {
  const c = useContents();
  const zones = c("zones", ZONES.join(", ")).split(",").map((z) => z.trim()).filter(Boolean);
  const items = [...zones, "Operativi in tutto il Veneto"];
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((z, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-semibold uppercase tracking-[0.2em] text-sm sm:text-base text-metal/90 px-6">
            {z}
          </span>
          <span className="w-1.5 h-1.5 bg-forest-glow rotate-45" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative overflow-hidden bg-forest border-y border-forest-mid py-4" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
